// extracted by mini-css-extract-plugin
export var text = "_4o-0";